import React, { useState } from 'react';
import { HelpCircle, ChevronDown, MessageSquare } from 'lucide-react';

const FAQPage = () => {
  const [openIdx, setOpenIdx] = useState(0);

  const faqs = [
    {
      q: 'What software development services does HOASP International provide?',
      a: 'We provide full-service web development, mobile app development (iOS/Android), custom ERP/CRM enterprise software, AI/ML integrations, cloud architecture (AWS/GCP), UI/UX design, and DevOps management.'
    },
    {
      q: 'How do you handle project pricing and billing models?',
      a: 'We offer flexible engagement models tailored to client needs: Fixed Price for well-defined scopes, Dedicated Team for ongoing roadmap execution, and Time & Materials for evolving agile projects.'
    },
    {
      q: 'What is your typical software development lifecycle (SDLC)?',
      a: 'Our SDLC follows Agile SCRUM methodologies: Discovery & Planning -> UI/UX Design -> Sprint Development -> Automated QA & Testing -> Deployment -> Post-Launch Maintenance.'
    },
    {
      q: 'Can you sign a Non-Disclosure Agreement (NDA) before project discussions?',
      a: 'Yes, absolutely. We strictly respect intellectual property confidentiality and sign mutual NDAs before reviewing sensitive business requirements or technical codebases.'
    },
    {
      q: 'Do you provide post-launch software maintenance and support?',
      a: 'Yes, we offer comprehensive SLA-backed maintenance packages including 24/7 server monitoring, security patching, performance optimization, and continuous feature enhancements.'
    }
  ];

  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-20 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-4">
            <HelpCircle className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400 text-sm font-semibold uppercase tracking-wider">
              Frequently Asked Questions
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            Got Questions? We Have <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-cyan-400 bg-clip-text text-transparent">Clear Answers</span>
          </h1>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed">
            Find answers to common questions about our engineering process, pricing models, technology stack, and security practices.
          </p>
        </div>
      </section>

      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-gray-950 border border-gray-800 rounded-2xl overflow-hidden">
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-800/40 transition-colors"
                >
                  <span className="text-lg font-bold text-white pr-4">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} />
                </button>
                {openIdx === idx && (
                  <div className="px-6 pb-6 text-gray-300 text-sm leading-relaxed border-t border-gray-800/60 pt-4">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
